import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import { navigationEvent } from 'layers/navigation/store/operations'
import { operations as userSessionOperations } from 'store/userSessionManager'
import { ADMIN_DASHBOARD_ENTRY_ID } from 'utils/entryIds'
import PlaybookSteps from './component'

const PlaybookStepsContainer = ({
  adminSetK8PlaybookStepsDropdown,
  familyLetterSent,
  goalsAreCompleted,
  goalsIsInDraft,
  implementationApproachIsCompleted,
  kickoffHosted,
  kickoffPrepared,
  linkDropdownDisplayTitle,
  linkMenu,
  navigationEvent,
  panelData,
  programStartDateIsCompleted,
  purposeIsCompleted,
  purposeIsInDraft,
  siteId,
  siteName,
  stateDropdownOption,
  userInvitationMethod,
}) => {
  useEffect(() => {}, [
    familyLetterSent,
    goalsAreCompleted,
    goalsIsInDraft,
    implementationApproachIsCompleted,
    kickoffHosted,
    kickoffPrepared,
    linkDropdownDisplayTitle,
    linkMenu,
    navigationEvent,
    programStartDateIsCompleted,
    purposeIsCompleted,
    purposeIsInDraft,
    stateDropdownOption,
    siteId,
    siteName,
    userInvitationMethod,
  ])

  return (
    <PlaybookSteps
      adminSetK8PlaybookStepsDropdown={adminSetK8PlaybookStepsDropdown}
      familyLetterSent={familyLetterSent}
      goalsAreCompleted={goalsAreCompleted}
      goalsIsInDraft={goalsIsInDraft}
      implementationApproachIsCompleted={implementationApproachIsCompleted}
      kickoffHosted={kickoffHosted}
      kickoffPrepared={kickoffPrepared}
      linkDropdownDisplayTitle={linkDropdownDisplayTitle}
      linkMenu={linkMenu}
      navigationEvent={navigationEvent}
      panelData={panelData}
      programStartDateIsCompleted={programStartDateIsCompleted}
      purposeIsCompleted={purposeIsCompleted}
      purposeIsInDraft={purposeIsInDraft}
      siteId={siteId}
      siteName={siteName}
      stateDropdownOption={stateDropdownOption}
      userInvitationMethod={userInvitationMethod}
    />
  )
}

PlaybookStepsContainer.propTypes = {
  adminSetK8PlaybookStepsDropdown: PropTypes.func,
  familyLetterSent: PropTypes.bool,
  goalsAreCompleted: PropTypes.bool,
  goalsIsInDraft: PropTypes.bool,
  implementationApproachIsCompleted: PropTypes.bool,
  kickoffHosted: PropTypes.bool,
  kickoffPrepared: PropTypes.bool,
  linkDropdownDisplayTitle: PropTypes.string,
  linkMenu: PropTypes.array,
  navigationEvent: PropTypes.func,
  panelData: PropTypes.array,
  programStartDateIsCompleted: PropTypes.bool,
  purposeIsCompleted: PropTypes.bool,
  purposeIsInDraft: PropTypes.bool,
  siteId: PropTypes.string,
  siteName: PropTypes.string,
  stateDropdownOption: PropTypes.object,
  userInvitationMethod: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const { contentful } = state || {}
  const { userSessionManager } = state || {}
  const {
    adminDashboard: {
      k8: { playbookStepsDropdown },
    },
  } = userSessionManager || {}
  const panelData =
    contentful?.[ADMIN_DASHBOARD_ENTRY_ID]?.payload?.leaderActivationPanel1 ||
    []
  const { navigationEvent } = ownProps || {}
  const adminK8Sites = licenseSelectors.selectActiveAdminK8Sites(state)
  const site = ownProps?.site || adminK8Sites?.[0] || {}
  const { sitePreferences = {} } = site || {}
  const stateDropdownOption = playbookStepsDropdown?.[site.id] || null
  const {
    classCreationGoalDate,
    classCreationGoalDateIsCompleted,
    classCreationGoalValue,
    classCreationGoalValueIsCompleted,
    counselorLed,
    familyLetterSent,
    goal3Date,
    goal3Text,
    goal4Date,
    goal4Text,
    goal5Date,
    goal5Text,
    implementationType,
    kickoffHosted,
    kickoffPrepared,
    lessonCompletionGoalDate,
    lessonCompletionGoalDateIsCompleted,
    lessonCompletionGoalValue,
    lessonCompletionGoalValueIsCompleted,
    programIsEnabled,
    programStartDate,
    purpose,
    purposeIsCompleted,
    teacherLed,
    userInvitationMethod,
  } = sitePreferences?.k5Digital || {}

  const goalsAreCompleted =
    (classCreationGoalDate &&
      classCreationGoalDateIsCompleted &&
      classCreationGoalValue &&
      classCreationGoalValueIsCompleted &&
      lessonCompletionGoalDateIsCompleted &&
      lessonCompletionGoalValueIsCompleted) ||
    false
  const goalsIsInDraft =
    !goalsAreCompleted &&
    (classCreationGoalDate ||
      classCreationGoalValue ||
      goal3Date ||
      goal3Text ||
      goal4Date ||
      goal4Text ||
      goal5Date ||
      goal5Text ||
      lessonCompletionGoalDate ||
      lessonCompletionGoalValue)
  const implementationApproachIsCompleted =
    (!!implementationType &&
      (teacherLed || counselorLed) &&
      (programIsEnabled || sitePreferences?.mspDigital?.programIsEnabled)) ||
    false
  const programStartDateIsCompleted = !!programStartDate
  const purposeIsInDraft = !purposeIsCompleted && purpose?.length > 0

  return {
    familyLetterSent,
    goalsAreCompleted,
    goalsIsInDraft,
    implementationApproachIsCompleted,
    kickoffHosted,
    kickoffPrepared,
    navigationEvent,
    panelData,
    programStartDateIsCompleted,
    purposeIsCompleted,
    purposeIsInDraft,
    siteId: site.id,
    siteName: site.name,
    stateDropdownOption,
    userInvitationMethod,
  }
}

const mapDispatchToProps = {
  navigationEvent,
  adminSetK8PlaybookStepsDropdown:
    userSessionOperations.adminSetK8PlaybookStepsDropdown,
}

const mapper = entry => {
  const { displayTitle, linkMenu } = entry || {}
  return {
    linkDropdownDisplayTitle: displayTitle,
    linkMenu,
  }
}

const options = {
  entryId: '7CIaQNOLCEQvJMd8GHkCeP',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    PlaybookStepsContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
